import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'risk',
  standalone: false,
})
export class RiskPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  private readonly levelKeys = [
    'veryHighRisk',
    'highRisk',
    'moderateRisk',
    'lowRisk',
    'veryLowRisk',
    'minimalRisk',
    'negligibleRisk',
    'safe',
    'verySafe',
    'extremelySafe',
    'noRisk',
  ];

  transform(value: number): string {
    if (value < 0 || value > 10 || isNaN(value)) {
      return this.translate.instant('enums.riskLevel.invalid');
    }
    const key = this.levelKeys[Math.floor(value)];
    return this.translate.instant(`enums.riskLevel.${key}`);
  }
}
